import { __awaiter, __extends, __generator } from "tslib";
import React, { Component } from "react";
import { View, Text, Image } from "react-native";
import { PnmacChatWindow, PnmacHeader, PnmacChatAvatar } from '../';
import SpeechRecognition from 'react-speech-recognition';
import { getActiveFeatures, findUpTag, endsWith, windowObject } from '../utils.js';
import PnmacMicrophone from "../components/Chat/Microphone";
import { SHOW_CHAT, CHAT_MIC_IS_ON, CHAT_SPEAKER_IS_ON, CHAT_IS_SPEAKING, CHAT_SESSION_DATA, CHAT_MINIMIZED, CHAT_IS_BLOCKED, LIVE_AGENT_JOINED, TRANSFER_TO_AGENT, AGENT_SESSION_TOKEN, globalHeaders, SAVE_WATSON_LATEST_MSG, CHANGE_LANGUAGE, CHAT_MESSAGES } from '../redux/actions/actions';
import { isMobile } from "react-device-detect";
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from '../events';
var MacChat = /** @class */function (_super) {
  __extends(MacChat, _super);
  function MacChat(props) {
    var _this = _super.call(this, props) || this;
    _this.setEventListener = function (func) {
      var layout = _this.props.layout;
      window.addEventListener("keyup", function (event) {
        var _a;
        if (event.keyCode == 13 && layout.showChat && !layout.pennyWise) {
          var message = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value;
          if ((message === null || message === void 0 ? void 0 : message.trim().length) > 0) {
            func();
          }
        }
      });
    };
    _this.handleMicStatusChange = function (listening) {
      //console.log("handleMicStatusChange", listening);
    };
    _this.handleMicOnEvent = function (listening) {
      var pennyCanHear = _this.props.layout.pennyCanHear;
      if (pennyCanHear) {
        SpeechRecognition.stopListening();
        _this.props.dispatch({
          type: CHAT_MIC_IS_ON,
          pennyCanHear: false
        });
      } else {
        //SpeechRecognition.startListening({ continuous: true });
        if (SpeechRecognition.isListening) {
          SpeechRecognition.stopListening();
        }
        SpeechRecognition.startListening();
        _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Mic start Listening", 0);
        _this.props.dispatch({
          type: CHAT_MIC_IS_ON,
          pennyCanHear: true
        });
        _this.props.dispatch({
          type: CHAT_SPEAKER_IS_ON,
          pennyCanTalk: true
        });
      }
      if (_this.chatRef && _this.chatRef.current && _this.chatRef.current.setChatState) {
        setTimeout(function () {
          _this.chatRef.current.setChatState();
        }, 500);
      }
    };
    _this.handlePennyEndedSpeaking = function () {
      _this.setState({
        isSpeaking: false
      }, function () {
        _this.props.dispatch({
          type: CHAT_IS_SPEAKING,
          isSpeaking: false
        });
        _this.setState({
          isSpeaking: false
        });
        if (_this.chatRef && _this.chatRef.current && _this.chatRef.current.setChatState) {
          setTimeout(function () {
            _this.chatRef.current.setChatState({
              isSpeaking: false
            });
          }, 500);
        }
      });
    };
    _this.canUserMakePayment = function () {
      var _a;
      var makeApPayment = (_a = _this.props.layout.paymentModel) === null || _a === void 0 ? void 0 : _a.canMakePayment;
      //if (makeApPayment) {
      //    let status = this.props.layout.selectedLoanAvailability?.status;
      //    makeApPayment = !modificationOrDelinquent(status, this.props.layout.modPortalVisible);
      //}
      return makeApPayment;
    };
    _this.onLiveAgentTyping = function (isTyping, data) {};
    _this.onAgentMessageReceived = function (evt, data, layout, connectUsrData) {
      if (evt && evt.ContentType && evt.ContentType == "application/vnd.amazonaws.connect.event.chat.ended") {
        _this.onliveAgentSessionEnded(layout, connectUsrData);
      }
      if (evt && evt.DisplayName) {
        if (evt.DisplayName != "Penny" && evt.DisplayName != _this.props.layout.liveAgentName && evt.ContentType == "text/plain") {
          _this.props.dispatch({
            type: LIVE_AGENT_JOINED,
            liveAgentName: evt.DisplayName
          });
        }
      }
      var chatMessages = layout.chatMessages;
      if (!evt.DisplayName) {
        if (chatMessages && chatMessages.length > 0) {
          var sortedAgentMsgs = chatMessages.filter(function (s) {
            return s.fromLiveAgent;
          });
          if (sortedAgentMsgs) {
            var sortedMessages = sortedAgentMsgs.sort(function (a, b) {
              return b.createdAt > a.createdAt ? 1 : -1;
            });
            var lastMsgAgent = sortedMessages[0].user.name;
            if (lastMsgAgent) {
              _this.props.dispatch({
                type: LIVE_AGENT_JOINED,
                liveAgentName: lastMsgAgent
              });
            }
          }
        }
      }
    };
    _this.onliveAgentSessionEnded = function (layout, connectUsrData) {
      //place holder
    };
    _this.onAgentConnectionSuccess = function (evt, conn, session, layout) {};
    _this.cleanupLiveAgentSession = function () {
      _this.props.dispatch({
        type: TRANSFER_TO_AGENT,
        transferToLiveAgent: false
      });
      _this.props.dispatch({
        type: AGENT_SESSION_TOKEN,
        startAgentParams: null
      });
    };
    _this.getFormattedChatLogBodyHtml = function (layout, connectUsrData) {
      var htmlBody = "<h1 style='color:red'>-- CHAT LOG: DONOT RESPOND --</h1> <br/>";
      layout === null || layout === void 0 ? void 0 : layout.chatMessages.map(function (m) {
        if (m.user.name == "MaCh") {
          m.user.name = "Penny";
        }
        var username = connectUsrData.firstName;
        if (m.user.name) {
          username = m.user.name;
        }
        htmlBody += "<p>".concat(username, ": ").concat(m.text, "<br/>");
        if (m.children && m.children.length > 0) {
          htmlBody += "<ul>";
          m.children.map(function (c) {
            htmlBody += "<li>".concat(c.label, "</li>");
          });
          htmlBody += "</ul>";
        }
        htmlBody += "</p>";
      });
      return htmlBody;
    };
    _this.getFormattedChatLogBodyText = function (layout, connectUsrData) {
      var textBody = "";
      layout === null || layout === void 0 ? void 0 : layout.chatMessages.map(function (m) {
        if (m.user.name == "MaCh") {
          m.user.name = "Penny";
        }
        var username = connectUsrData.firstName;
        if (m.user.name) {
          username = m.user.name;
        }
        textBody += "\n".concat(username, ": ").concat(m.text, "\n");
        if (m.children && m.children.length > 0) {
          m.children.map(function (c) {
            textBody += "\n ".concat(c.label);
          });
        }
      });
      if (textBody && textBody.length > 0) {
        textBody = textBody.replace(/<[^>]+>/g, '');
        if (textBody.length > 1000) {
          textBody = textBody.substring(textBody.length - 1001);
        }
      }
      return "CHAT LOG\n ".concat(textBody);
    };
    _this.shouldTransferToAgent = function () {
      return _this.props.layout.transferToLiveAgent;
    };
    _this.getStartChatData = function (layout, force) {
      return __awaiter(_this, void 0, void 0, function () {
        var fetchResp, jsonResp, params;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!layout.transferToLiveAgent) {
                this.props.dispatch({
                  type: TRANSFER_TO_AGENT,
                  transferToLiveAgent: true
                });
              }
              if (!(!force && layout.startAgentParams)) return [3 /*break*/, 1];
              return [2 /*return*/, layout.startAgentParams];
            case 1:
              return [4 /*yield*/, fetch("api/chat/get_connect_start_params", {
                method: "GET",
                headers: globalHeaders(layout),
                body: null
              })];
            case 2:
              fetchResp = _a.sent();
              if (!(fetchResp.status == 200)) return [3 /*break*/, 4];
              return [4 /*yield*/, fetchResp.json()];
            case 3:
              jsonResp = _a.sent();
              params = {
                "ContactId": jsonResp.contactId,
                "ParticipantId": jsonResp.participantId,
                "ParticipantToken": jsonResp.participantToken
              };
              this.props.dispatch({
                type: AGENT_SESSION_TOKEN,
                startAgentParams: params
              });
              return [2 /*return*/, params];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    };
    _this.getConnectUserData = function (borrowerId) {
      var res = {
        sid: 0,
        firstName: null
      };
      if (borrowerId && _this.props.layout.borrowerLoans && _this.props.layout.borrowerLoans.length > 0) {
        var thisUsr = _this.props.layout.borrowerLoans.find(function (e) {
          return e.borrowerId == borrowerId;
        });
        if (thisUsr) {
          res.sid = thisUsr.last4Ssn;
          res.firstName = thisUsr.firstName;
        }
      }
      return res;
    };
    _this.getUserId = function (layout) {
      if (layout.userProfile) {
        return layout.userProfile.user_id;
      }
      return null;
    };
    _this.state = {
      loanNumber: null,
      showMessage: null,
      pennyCanHear: false,
      showChat: false,
      isSpeaking: false,
      isListening: false,
      timer: null,
      closeIconHover: false,
      incomingMessages: [/*#__PURE__*/React.createElement("div", {
        key: "initial"
      })],
      hubIntitailized: false,
      chatIsInitialized: false
    };
    _this.chatRef = /*#__PURE__*/React.createRef();
    _this.source = {
      stop: function () {}
    };
    return _this;
  }
  MacChat.prototype.togglePennyTalk = function () {
    var layout = this.props.layout;
    this.source.stop();
    this.props.dispatch({
      type: CHAT_SPEAKER_IS_ON,
      pennyCanTalk: !layout.pennyCanTalk
    });
    this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, (!layout.pennyCanTalk ? 'Enable' : 'Disable') + " Penny Talk", 0);
  };
  MacChat.prototype.scrollToBottom = function () {
    this.el.scrollIntoView();
  };
  MacChat.prototype.canShowChat = function () {
    if (this.props.layout.chatToggles) {
      var pagesToshow = this.props.layout.chatToggles.pages;
      if (pagesToshow && pagesToshow.length > 0) {
        return pagesToshow.indexOf(windowObject.location.pathname) > -1;
      }
      return true; //if no pages specified show in all pages.
    } else if (windowObject.location.pathname == "/MessageCenter") {
      return true;
    }
    return false;
  };
  MacChat.prototype.liveAgentEnabled = function () {
    if (this.props.layout.chatToggles && this.props.layout.chatToggles.enableLiveAgent) {
      var loansAllowed = this.props.layout.chatToggles.loansForLiveAgent;
      if (loansAllowed.length > 0) {
        return loansAllowed.indexOf(this.props.layout.selectedLoanNumber) > -1;
      }
      return true;
    }
    return false;
  };
  MacChat.prototype.showChatInMobile = function () {
    if (this.props.layout.chatToggles && this.props.layout.chatToggles.enableInMobile) {
      return true;
    }
    return false;
  };
  MacChat.prototype.getAgentWaitConnTimeOut = function () {
    if (this.props.layout.chatToggles) {
      return this.props.layout.chatToggles.agentTimeout || 60;
    }
    return 60; //default 60 sec
  };
  MacChat.prototype.getAgentTriggerIntents = function () {
    if (this.props.layout.chatToggles) {
      return this.props.layout.chatToggles.agentTriggerIntents || ['general_connect_to_agent'];
    }
    return ['general_connect_to_agent'];
  };
  MacChat.prototype.componentDidMount = function () {
    var menu = document.getElementById("chatContainer");
    if (menu) {
      menu.addEventListener('contextmenu', function (event) {
        return event.preventDefault();
      });
    }
  };
  MacChat.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      layout = _a.layout,
      translations = _a.translations,
      matches = _a.matches;
    var _b = layout || {},
      chatMessages = _b.chatMessages,
      pennyCanTalk = _b.pennyCanTalk,
      pennyCanHear = _b.pennyCanHear,
      isSpeaking = _b.isSpeaking,
      isListening = _b.isListening,
      chatIsInitialized = _b.chatIsInitialized,
      chatIsBlocked = _b.chatIsBlocked;
    var trans = translations && translations[windowObject.location.pathname] ? JSON.parse(translations[windowObject.location.pathname]) : [];
    var liveAgentToggled = this.liveAgentEnabled();
    var agentWaitConnTimeOut = this.getAgentWaitConnTimeOut();
    var connectUsrData = this.getConnectUserData(layout === null || layout === void 0 ? void 0 : layout.borrowerId);
    var idsUserId = layout ? this.getUserId(layout) : null;
    var triggersForConnect = this.getAgentTriggerIntents();
    return /*#__PURE__*/React.createElement("div", null, idsUserId != null && (!this.showChatInMobile() ? (matches.medium || matches.large) && !isMobile : true) && getActiveFeatures(layout === null || layout === void 0 ? void 0 : layout.features, "MacChat", layout === null || layout === void 0 ? void 0 : layout.whitelisted) && (layout.showChat || this.canShowChat()) ? /*#__PURE__*/React.createElement("div", {
      role: "complementary",
      id: "chatContainer"
    }, layout.showChat && !layout.pennyWise && /*#__PURE__*/React.createElement(PnmacChatWindow, {
      closeLiveChat: function (closeLiveChat) {
        return _this.closeLiveChat = closeLiveChat;
      },
      layout: layout,
      matches: matches,
      loadEarlier: false,
      ref: this.chatRef,
      maxLength: layout.transferToLiveAgent && liveAgentToggled ? "500" : "120",
      isSpeakerOn: false,
      isMicOn: pennyCanHear || false,
      isSpeaking: false,
      isListening: isListening || false,
      isBlocked: chatIsBlocked || false,
      chatIsInitialized: chatIsInitialized,
      sessionId: layout.chatSessionId || "",
      userChatSessionId: layout.userChatSessionId || 0,
      liveAgentEnabled: liveAgentToggled,
      liveAgentConnTimeOut: agentWaitConnTimeOut,
      userDisplayName: connectUsrData.firstName,
      sid: connectUsrData.sid,
      idsUserId: idsUserId,
      intentsToTriggerConnect: triggersForConnect,
      lastWatsonMessage: layout.lastWatsonMessage,
      fnCanMakeAPayment: this.canUserMakePayment,
      socketPrepend: function (args) {},
      socketRequest: function (messages, args) {
        try {
          _this.props.dispatch({
            type: CHAT_MESSAGES,
            messages: messages
          });
          if (args === null || args === void 0 ? void 0 : args.isBlocked) {
            _this.props.dispatch({
              type: CHAT_IS_BLOCKED,
              chatIsBlocked: args.isBlocked
            });
          }
          if ((args === null || args === void 0 ? void 0 : args.transferToLiveAgent) && (args === null || args === void 0 ? void 0 : args.transferToLiveAgent) == true) {
            _this.props.dispatch({
              type: TRANSFER_TO_AGENT,
              transferToLiveAgent: args.transferToLiveAgent
            });
          }
          if ((args === null || args === void 0 ? void 0 : args.userChatSessionId) && (args === null || args === void 0 ? void 0 : args.userChatSessionId) > 0) {
            _this.props.dispatch({
              type: CHAT_SESSION_DATA,
              chatSessionId: args.sessionId,
              userChatSessionId: args.userChatSessionId,
              chatReadyToResume: true
            });
          }
          if (args === null || args === void 0 ? void 0 : args.lastWatsonMessage) {
            _this.props.dispatch({
              type: SAVE_WATSON_LATEST_MSG,
              lastWatsonMessage: args.lastWatsonMessage
            });
          }
          if (_this.chatRef && _this.chatRef.current) {
            //setTimeout(() => {
            //    this.props.dispatch({
            //        type: CHAT_SESSION_DATA, chatSessionId: this.chatRef.current.state.sessionId,
            //        userChatSessionId: this.chatRef.current.state.userChatSessionId,
            //        chatReadyToResume: true
            //    });
            //}, 500);
            if (_this.chatRef.current.setChatState) {
              setTimeout(function () {
                _this.chatRef.current.setChatState({
                  isInitialized: true,
                  chatIsInitialized: true,
                  isBlocked: layout.chatIsBlocked
                });
              }, 500);
            }
          }
          setTimeout(function () {
            _this.setState({
              chatIsInitialized: true
            });
          }, 500);
        } catch (err) {
          console.log("Error Mac Chat", err);
        }
      },
      url: "/api/chat/send_chat",
      speak: function (message) {
        if (layout.pennyCanTalk) {
          fetch("".concat(layout.pennyHomeUrl, "api/chat/speak"), {
            method: "POST",
            headers: globalHeaders(layout),
            body: JSON.stringify({
              message: message,
              LoanId: layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber
            })
          }).then(function (e) {
            return e.text();
          }).then(function (blob) {
            try {
              _this.source.stop();
              if (layout.pennyCanTalk) {
                _this.props.dispatch({
                  type: CHAT_IS_SPEAKING,
                  isSpeaking: true
                });
                var context_1 = new AudioContext();
                fetch(blob).then(function (response) {
                  return response.arrayBuffer();
                }).then(function (arrayBuffer) {
                  return context_1.decodeAudioData(arrayBuffer);
                }).then(function (audioBuffer) {
                  _this.source = context_1.createBufferSource();
                  _this.source.buffer = audioBuffer;
                  _this.source.connect(context_1.destination);
                  _this.source.start();
                  _this.source.addEventListener('ended', function () {
                    var pennyCanHear = _this.props.layout.pennyCanHear;
                    if (pennyCanHear) {
                      if (SpeechRecognition.isListening) {
                        SpeechRecognition.stopListening();
                      }
                      SpeechRecognition.startListening();
                    }
                  });
                });
              }
            } catch (e) {
              console.log(e);
            }
          });
        }
      },
      agentSessionUrl: "/api/chat/agent_session_tracker",
      loanId: layout.selectedLoanNumber,
      usePost: true,
      mobile: "web",
      token: layout.token,
      setEventListener: this.setEventListener,
      existingMessages: chatMessages,
      onLinkPress: function (link) {
        return console.log("Test", link);
      },
      liveAgentName: layout.liveAgentName,
      agentApiUrl: layout.liveAgentUrl,
      agentContactFlowId: layout.liveAgentFlowId,
      agentInstanceId: layout.liveAgentInstanceId,
      onLiveAgentTyping: this.onLiveAgentTyping,
      onAgentMessageReceived: function (evt, data) {
        return _this.onAgentMessageReceived(evt, data, layout, connectUsrData);
      },
      onAgentConnectionSuccess: function (evt, conn, connSession) {
        return _this.onAgentConnectionSuccess(evt, conn, connSession, layout);
      },
      getHistoryToAgentForContext: function () {
        return _this.getFormattedChatLogBodyText(layout, connectUsrData);
      },
      getStartChatData: function (force) {
        return __awaiter(_this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4 /*yield*/, this.getStartChatData(layout, force)];
              case 1:
                return [2 /*return*/, _a.sent()];
            }
          });
        });
      },
      transferToLiveAgent: layout.transferToLiveAgent,
      cleanupLiveAgentSession: function () {
        return _this.cleanupLiveAgentSession();
      },
      chatContainer: {
        backgroundColor: "white",
        height: matches.small ? "80%" : 500,
        width: matches.small ? "95%" : 500,
        margin: "0 auto",
        position: "fixed",
        zIndex: 1200,
        right: matches.small ? 10 : 20,
        bottom: matches.small ? 50 : 98
      },
      renderMessageText: function (data) {
        return /*#__PURE__*/React.createElement(View, {
          style: {
            padding: 10
          }
        }, /*#__PURE__*/React.createElement("div", {
          onClick: function (e) {
            e.preventDefault();
            var href = e.target.href;
            if (!href) {
              var closest = findUpTag(e.target, 'href');
              if (closest) {
                href = closest.href;
              }
            }
            var exceptionDomainNames = ['mycoverageinfo.com', 'ready.gov', 'weather.gov', 'insuranceclaimcheck.com', 'radar.weather.gov'];
            var exceptDomainUrlsPresent = false;
            if (href) {
              var currentUrl = new URL(href);
              var hostname = currentUrl === null || currentUrl === void 0 ? void 0 : currentUrl.hostname;
              exceptDomainUrlsPresent = exceptionDomainNames.some(function (domain) {
                return hostname === null || hostname === void 0 ? void 0 : hostname.endsWith(domain);
              });
            }
            if (href && (href.indexOf(hostname) > -1 || exceptDomainUrlsPresent) /*&& href.indexOf("?") == -1*/) {
              var arbitaryUrl = encodeURIComponent(href);
              var safeUrl = decodeURIComponent(arbitaryUrl);
              if (safeUrl != null) {
                var encoded_1 = new URL(href);
                var currentPage = window.location || window.document.location;
                var currentUrl = new URL(currentPage);
                if (currentUrl.origin != encoded_1.origin) {
                  window.open(encoded_1.href, "_blank", false);
                } else {
                  var features = layout.features.filter(function (f) {
                    return f.description && endsWith(f.description, encoded_1.pathname);
                  });
                  _this.props.history.push({
                    pathname: encoded_1.pathname,
                    state: {
                      fromChat: true
                    }
                  });
                }
              }
            }
          },
          dangerouslySetInnerHTML: {
            __html: data.currentMessage.text
          }
        }), /*#__PURE__*/React.createElement("div", {
          ref: function (el) {
            _this.el = el;
          }
        }));
      },
      header: function (toggleLivePerson, state, onSend) {
        return /*#__PURE__*/React.createElement(PnmacHeader, {
          containerStyles: {
            height: 75,
            marginBottom: 15,
            backgroundColor: '#003087'
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 15
          }
        }, /*#__PURE__*/React.createElement("div", {
          onClick: function () {
            return _this.setState({
              showChat: !_this.state.showChat
            });
          },
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexGrow: 0
          }
        }, /*#__PURE__*/React.createElement("img", {
          alt: "Chat avatar",
          style: {
            width: 50,
            height: 50,
            marginRight: 5
          },
          src: layout.isPrivateLabel ? require("../assets/townsgate-avatar-1.png") : require("../assets/ChatHeader.svg")
        })), /*#__PURE__*/React.createElement("div", {
          style: {
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            flexGrow: 5
          }
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          style: {
            color: "white",
            fontWeight: "bold"
          }
        }, "MacChat"), /*#__PURE__*/React.createElement("div", {
          style: {
            color: "white",
            fontWeight: "bold"
          }
        }, "Loan: ", layout.selectedLoanNumber))), /*#__PURE__*/React.createElement("div", {
          onClick: function () {
            return _this.togglePennyTalk();
          },
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexGrow: 0,
            cursor: "pointer"
          }
        }, /*#__PURE__*/React.createElement("img", {
          alt: !layout.pennyCanTalk ? 'speaker-off' : 'speaker-on',
          src: !layout.pennyCanTalk ? require("../assets/speaker-off.png") : require("../assets/speaker-on.png")
        })), /*#__PURE__*/React.createElement(PnmacMicrophone, {
          speechEnded: function (result) {
            onSend(result);
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Mic stop Listening and send message", 0);
          },
          pennyCanHear: layout.pennyCanHear,
          onStateChange: _this.handleMicStatusChange,
          imageForOn: require("../assets/mic-on.png"),
          handleMicOnEvent: _this.handleMicOnEvent,
          imageForOff: require("../assets/mic-off.png")
        })));
      }
    }), !layout.pennyWise && /*#__PURE__*/React.createElement("div", {
      style: {
        position: "fixed",
        zIndex: 1200,
        right: 20,
        bottom: 0
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: 100,
        height: 100
      },
      onClick: function () {
        _this.source.stop();
        if (_this.closeLiveChat) {
          _this.closeLiveChat();
        }
        if (_this.chatRef && _this.chatRef.current) {
          _this.chatRef.current.setChatState({
            chatBusyState: "isReady"
          });
        }
        _this.cleanupLiveAgentSession();
        _this.props.dispatch({
          type: SHOW_CHAT,
          showChat: !layout.showChat
        });
      }
    }, layout.showChat ? /*#__PURE__*/React.createElement(Image, {
      style: {
        width: '100%',
        height: '100%'
      },
      source: require("../assets/ChatCloseBubble.svg")
    }) : /*#__PURE__*/React.createElement(Image, {
      style: {
        width: '100%',
        height: '100%'
      },
      source: require("../assets/ChatOpenBubble.svg")
    })))) : null);
  };
  return MacChat;
}(Component);
export default MacChat;